import { Box, Grid, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface IDetailSectionProps {
  label: string;
  value?: string | null;
  isHalfSize?: boolean;
}

const translation_path = "page.doctorAgenda.appointmentDetails.";

export const DetailSection = memo(
  ({ label, value, isHalfSize }: IDetailSectionProps) => {
    const { t } = useTranslation();

    return (
      <Grid item xs={12} sm={isHalfSize ? 6 : undefined} md={isHalfSize ? 4 : undefined}>
        <Box py={2}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {label}
          </Typography>
          <Typography variant="body1" fontWeight="600">
            {value || t(translation_path + "not_informed")}
          </Typography>
        </Box>
      </Grid>
    );
  }
);
